import React from 'react';
import PropTypes from 'prop-types';

import Image from 'marketing-website/components/modules/Image';
import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';

import imageStyles from './style/image.module.css';

export default function SliderImage({ alt, src }) {
  const imageMaxWidth = 150;

  return (
    <div className={imageStyles.image}>
      <div className={imageStyles.inner}>
        <Image alt={alt} maxWidth={imageMaxWidth} src={src} />
      </div>
    </div>
  );
}

SliderImage.propTypes = {
  alt: PropTypes.string,
  src: propTypeEmptyString,
};



// WEBPACK FOOTER //
// ./src/components/modules/Media/MediaImageSlider/SliderImage/index.js